import { useAuth } from "hooks/use-auth";
import { DeleteUserButton } from "styles/styles";

export const DeleteUser = () => {
	const auth = useAuth();
	const checkDeleteUser = async () => {
		const answer = window.confirm('ユーザーを削除しますか？');
		if (answer) {
			const res = await auth.deleteUser();
			window.alert(res.message)
		}
	}
	return (
		<>
			<DeleteUserButton onClick={checkDeleteUser}>ユーザーの削除</DeleteUserButton>
		</>
	)
}